import Select from "../../../Components/InputFields/Select";
import Custom from "../../../Components/Buttons/Custom";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../../../config/api";
import SVG from "../../../Components/SVG";
import GradientBlue from "../../../Components/InputFields/GradientBlue";

export default function WithdrawModal({ setIsWithdrawOpen, accountId }) {
  const navigate = useNavigate();
  const [coin, setCoin] = useState(null);
  const [network, setNetwork] = useState(null);
  const [wallet, setWallet] = useState(null);
  const [fields, setFields] = useState(true);
  const [clicked, setClicked] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [error, setError] = useState(null);
  const [step, setStep] = useState(1);

  useEffect(() => {
    if (!coin || !wallet || !network) {
      setFields(false);
    } else {
      setFields(true);
    }
  }, [network, wallet, coin]);
  const handleSubmit = async (e) => {
    e.preventDefault();
    setClicked(true);
    if (!fields) {
      return;
    }
    setSubmitLoading(true);
    setError(null);
    try {
      let response = await fetch(
        `${API_BASE_URL}payment-payout/payout-request/${accountId}/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access")}`,
          },
          body: JSON.stringify({
            network: network,
            wallet_address: wallet,
          }),
        },
      );

      // If access token is invalid/expired → try refresh
      if (response.status === 401) {
        const refreshResponse = await fetch(
          `${API_BASE_URL}auth/trader/jwt/refresh/`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              refresh: localStorage.getItem("refresh"),
            }),
          },
        );

        if (!refreshResponse.ok) {
          // refresh failed → logout
          localStorage.removeItem("access");
          localStorage.removeItem("authCredentials");
          localStorage.removeItem("refresh");
          localStorage.removeItem("role");
          localStorage.removeItem("email");
          navigate("/signin");
          return; // ⬅️ IMPORTANT
        }

        const refreshData = await refreshResponse.json();
        localStorage.setItem("access", refreshData.access);

        // retry original request with new access token
        response = await fetch(
          `${API_BASE_URL}payment-payout/payout-request/${accountId}/`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("access")}`,
            },
            body: JSON.stringify({
              network: network,
              wallet_address: wallet,
            }),
          },
        );
      }

      if (!response.ok) {
        throw new Error(`https error! Status: ${response.status}`);
      }

      const data = await response.json();
      console.log("Account Data:", data);
      setSubmitLoading(false);
      setStep(2);
    } catch (error) {
      setSubmitLoading(false);
      setError("ثبت درخواست برداشت با خطا مواجه شد، مجدد تلاش کنید.");
      console.error("Error fetching account data:", error);
    }
  };

  if (step === 2) {
    return (
      <div className="p-5 w-full max-w-2xl min-h-96 rounded-2xl flex flex-col gap-6 justify-between bg-zi-bg2-light dark:bg-zi-bg2-dark drop-shadow-lg">
        <div className="w-full flex flex-col items-start gap-3">
          <div className="w-full flex items-start justify-between gap-3">
            <h5 className="font-medium text-base sm:text-xl text-zi-text-light dark:text-zi-text-dark overflow-hidden whitespace-nowrap text-ellipsis">
              ثبت درخواست برداشت سود
            </h5>
            <span onClick={() => setIsWithdrawOpen(false)}>
              <SVG
                name="close"
                classname="stroke-zi-text-light dark:stroke-zi-text-dark size-5 cursor-pointer"
              />
            </span>
          </div>
        </div>

        <div className="flex flex-col gap-4 items-center justify-center font-normal text-center text-sm sm:text-base text-zi-text-light/70 dark:text-zi-text-dark/70">
          <SVG
            name="check"
            classname="size-24 stroke-2 stroke-zi-text-light dark:stroke-zi-text-dark"
          />
          <p className="text-zi-text-light dark:text-zi-text-dark">
            درخواست برداشت سود شما با موفقیت ثبت شد.
          </p>
        </div>

        <div className="flex flex-col gap-3">
          <p className="font-light text-sm sm:text-base text-zi-text-light/70 dark:text-zi-text-dark/70">
            وضعیت درخواست از بخش تاریخچه برداشت قابل پیگیری است و حداکثر تا ۲۴
            ساعت آینده بررسی و پردازش خواهد شد.
          </p>
          <Custom
            onClick={() => navigate("/Transaction/History")}
            text="مشاهده وضعیت برداشت"
            className="bg-zi-gradient-button-blue mt-0 !text-base text-zi-text-dark w-full hocus:ring-1 hocus:ring-offset-1 hocus:ring-zi-border-dark"
          />
        </div>
      </div>
    );
  }

  return (
    <div className="w-full rounded-2xl p-5 flex flex-col gap-10 drop-shadow-lg bg-zi-bg2-light dark:bg-zi-bg2-dark">
      <div className="w-full flex items-start justify-between gap-3">
        <div className="w-full flex flex-col items-start gap-2">
          <h5 className="font-medium text-base sm:text-xl text-zi-text-light dark:text-zi-text-dark overflow-hidden whitespace-nowrap text-ellipsis">
            ثبت درخواست برداشت سود
          </h5>
          <p className="font-normal text-sm sm:text-base text-zi-text-light/70 dark:text-zi-text-dark/70">
            شبکه و آدرس کیف پول مقصد را برای ثبت درخواست برداشت وارد کنید.
          </p>
        </div>
        <span onClick={() => setIsWithdrawOpen(false)}>
          <SVG
            name="close"
            classname="stroke-zi-text-light dark:stroke-zi-text-dark size-5 cursor-pointer"
          />
        </span>
      </div>
      <div className="flex items-center gap-14">
        <div className="w-full flex flex-col gap-2.5">
          <span className="text-zi-text-light/50 dark:text-zi-text-dark/50">
            رمز ارز
          </span>
          <Select
            options={["USDT"]}
            onChange={(e) => {
              setCoin(e.target.value);
              setClicked(false);
            }}
          />
        </div>
        <div className="w-full flex flex-col gap-2.5">
          <span className="text-zi-text-light/50 dark:text-zi-text-dark/50">
            شبکه
          </span>
          <Select
            options={["TRC20", "BEP20"]}
            onChange={(e) => {
              setNetwork(e.target.value);
              setClicked(false);
            }}
          />
        </div>
      </div>

      <div className="w-full flex flex-col gap-2.5">
        <span className="text-zi-text-light/50 dark:text-zi-text-dark/50">
          آدرس کیف پول
        </span>
        <input
          className="bg-transparent py-1 px-2.5 border border-zi-border-dark rounded-lg w-full outline-none hocus:ring-1 hocus:ring-zi-border-dark [direction:ltr] text-zi-text-light dark:text-zi-text-dark"
          onInput={(e) => {
            setWallet(e.target.value);
            setClicked(false);
          }}
        />
      </div>
      {clicked && !fields && (
        <p className="text-red-500 text-sm">لطفا همه فیلد‌ها را پر کنید</p>
      )}
      {error && <p className="text-red-500 text-sm">{error}</p>}

      <div className="flex items-center gap-3">
        <Custom
          text="انصراف"
          onClick={() => setIsWithdrawOpen(false)}
          className="w-full border border-zi-border-dark !text-sm !rounded-lg !py-[11px] !px-3 bg-zi-bg1-light dark:bg-zi-bg1-dark text-zi-text-light dark:text-zi-text-dark hocus:ring-1 hocus:ring-zi-border-dark"
        />
        {!submitLoading ? (
          <GradientBlue
            type="submit"
            value="ثبت درخواست"
            onClick={handleSubmit}
          />
        ) : (
          <GradientBlue
            isLoader={true}
            type="submit"
            value="ثبت درخواست"
            onClick={() => {}}
          />
        )}
      </div>
    </div>
  );
}
